<div [formGroup]="modeValorisationForm">
  <div class='container'>
    <div class="card">
      <div class="card-body">
        <h2 class="btn-ouline-success-title">Mode valorisation <span class="required">*</span></h2>
        <form [formGroup]="modeValorisationForm">
          <div class="row">
            <div class="btn-group d-block" role="group">
              <ng-container *ngFor="let modeValorisation of modeValorisations">
                <input type="radio" class="btn-check" formControlName="modeValorisation" [value]="modeValorisation.code" [id]="modeValorisation.code"
                      (change)="onRadioChange(modeValorisation.code)" tabindex="1">
                <label class="btn btn-outline-success" [for]="modeValorisation.code"> {{ modeValorisation.code }} - {{ modeValorisation.label }}</label>
              </ng-container>
            </div>
            <div class="invalid-feedback" *ngIf="modeValorisationForm.get('modeValorisation').invalid && (modeValorisationForm.get('modeValorisation').dirty || modeValorisationForm.get('modeValorisation').touched)">
              <div *ngIf="modeValorisationForm.get('modeValorisation').errors?.['required']">Le mode valorisation est obligatoire</div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div *ngIf="modeValorisationForm.get('modeValorisation').value === 'AC'">
      <div class='card'>
        <div class='card-body'>
            <div class="row">
              <div class="col-12 col-xxl-6">
                <div class="row">
                    <label for="puissanceSouscriteKVA" class="form-label">Puissance souscrite  <span class="required">*</span></label>
                    <div class="col-10">
                      <input type="number" class="form-control" id="puissanceSouscriteKVA" formControlName="puissanceSouscriteKVA" placeholder="Ex : 343 kVA" tabindex="34"
                             [ngClass]="modeValorisationForm.get('puissanceSouscriteKVA').invalid && (modeValorisationForm.get('puissanceSouscriteKVA').dirty
                                || modeValorisationForm.get('puissanceSouscriteKVA').touched) ? 'is-invalid' : ''">
                      <div class="invalid-feedback">
                        <div *ngIf="modeValorisationForm.get('puissanceSouscriteKVA').errors?.['pattern']">La puissance souscrite n'est pas valide</div>
                        <div *ngIf="modeValorisationForm.get('puissanceSouscriteKVA').errors?.['required']">La puissance souscrite est obligatoire</div>
                      </div>
                    </div>
                    <div class="col-2">
                      <span class="spanTextMiddle">kVA</span>
                    </div>
                </div>
              </div>
            <div class="col-12 col-xxl-6">
              <label for="mecanismeReventeSurplus" class="form-label">Mécanisme de revente de surplus <span class="required">*</span></label>
              <select
                id="mecanismeReventeSurplus"
                class="form-select"
                formControlName="mecanismeReventeSurplus"
                tabindex="36"
                [ngClass]="modeValorisationForm.get('mecanismeReventeSurplus').invalid && (modeValorisationForm.get('mecanismeReventeSurplus').dirty || modeValorisationForm.get('mecanismeReventeSurplus').touched) ? 'is-invalid' : ''">
                <option [ngValue]="null"></option>
                <option *ngFor="let mecanismeRevente of mecanismesRevente" [ngValue]="mecanismeRevente.code">
                  {{ mecanismeRevente.label }}
                </option>
              </select>
              <div class="invalid-feedback">
                <div *ngIf="modeValorisationForm.get('mecanismeReventeSurplus').errors?.['required']">Le mécanisme de revente de surplus est obligatoire</div>
              </div>
              </div>
          </div>
        </div>
      </div>
      <div class='card'>
        <div class='card-body'>
          <h2 class="card-title">Informations site</h2>
          <div class="row">
            <div class="col-12 col-xxl-6">
              <div class="form-group form-check">
                <span class="spanCheckbox">Place disponible dans le local TGBT ? (cocher si oui)</span>
                <input class="form-check-input" type="checkbox" formControlName="dispoTGBT" tabindex="37">
              </div>
            </div>
            <div class="col-12 col-xxl-6">
              <div class="form-group form-check">
                <span class="spanCheckbox">Relais de découplage déjà présent sur le site ? (cocher si oui)</span>
                <input class="form-check-input" type="checkbox" formControlName="automate" tabindex="38">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class='card' style='padding-bottom: 5px;'>
        <div class='card-body'>
          <h2 class="card-title">Bilan energétique</h2>
            <div class="row">
              <div class="col-10 col-xxl-10 position-relative">
                <label for="prm" class="form-label">Courbe de charge (PRM) <span class="required">*</span></label>

                <div id="prm" class="form-control custom-select-trigger d-flex justify-content-between align-items-center"
                    [ngClass]="modeValorisationForm.get('prm').invalid && (modeValorisationForm.get('prm').dirty || modeValorisationForm.get('prm').touched) ? 'is-invalid' : ''"
                    (click)="isPrmDropdownOpen = !isPrmDropdownOpen"
                    tabindex="39">
                  <span>{{ modeValorisationForm.get('prm').value || '' }}</span>
                  <i class="bi bi-chevron-down"></i>
                </div>

                <div class="custom-select-panel" *ngIf="isPrmDropdownOpen">
                  <div *ngFor="let prmLigne of prmCodes"
                      class="custom-select-option d-flex justify-content-between align-items-center"
                      [class.selected]="modeValorisationForm.get('prm').value === prmLigne.code"
                      (click)="selectPrm(prmLigne.code)">
                    <span>{{ prmLigne.code }}</span>
                    <i class="bi bi-x-circle-fill text-danger prm-delete-icon"
                      title="Supprimer ce PRM"
                      (click)="deletePrm($event, prmLigne.code)"></i>
                  </div>
                  <div *ngIf="!prmCodes.length" class="custom-select-option text-muted">
                    Aucune donnée
                  </div>
                </div>

                <div class="invalid-feedback">
                  <div *ngIf="modeValorisationForm.get('prm').errors?.['required']">Le prm est obligatoire</div>
                </div>
              </div>
              <div class="col-2 col-xxl-2">
                <div class='mb-2'>
                  <label for="fichier-button" class="form-label"></label>
                </div>
                <button type="button" id="fichier-button" (click)="openModal()"
                        class="btn btn-primary"  [disabled]="formIsSubmitting"
                        title='Charger nouveau fichier'>
                         <i class="bi bi-upload custom-outils-bi"></i>
                  </button>
              </div>
            </div>
        </div>

        <div class='container'>
        <h2 class="card-title">Tarifs de l'énergie (c€/kWh)</h2>
          <div class="row">

            <div class="col-12 col-xxl-6">
              <label for="tarifHch" class="form-label">Heure Creuse Haute (HCH)  <span class="required">*</span></label>
              <input type="number" class="form-control" id="tarifHch" formControlName="tarifHch" placeholder="Ex : 3.07" tabindex="40"
                     [ngClass]="modeValorisationForm.get('tarifHch').invalid && (modeValorisationForm.get('tarifHch').dirty
                  || modeValorisationForm.get('tarifHch').touched) ? 'is-invalid' : ''">
              <div class="invalid-feedback">
                <div *ngIf="modeValorisationForm.get('tarifHch').errors?.['required']">Heure Creuse Haute est obligatoire</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-xxl-6">
              <label for="tarifHph" class="form-label">Heure Pleine Haute (HPH)  <span class="required">*</span></label>
              <input type="number" class="form-control" id="tarifHph" formControlName="tarifHph" placeholder="Ex : 3.07" tabindex="41"
                     [ngClass]="modeValorisationForm.get('tarifHph').invalid && (modeValorisationForm.get('tarifHph').dirty
                  || modeValorisationForm.get('tarifHph').touched) ? 'is-invalid' : ''">
              <div class="invalid-feedback">
                <div *ngIf="modeValorisationForm.get('tarifHph').errors?.['required']">Heure Pleine Haute est obligatoire</div>
              </div>
            </div>
            <div class="col-12 col-xxl-6">
              <label for="tarifHpt" class="form-label">Heure Pointe (HPT)  <span class="required">*</span></label>
              <input type="number" class="form-control" id="tarifHpt" formControlName="tarifHpt" placeholder="Ex : 3.07" tabindex="42"
                       [ngClass]="modeValorisationForm.get('tarifHpt').invalid && (modeValorisationForm.get('tarifHpt').dirty
                    || modeValorisationForm.get('tarifHpt').touched) ? 'is-invalid' : ''">
              <div class="invalid-feedback">
                <div *ngIf="modeValorisationForm.get('tarifHpt').errors?.['required']">Heure Pointe est obligatoire</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-xxl-6">
              <label for="tarifHcb" class="form-label">Heure Creuse Basse (HCB)  <span class="required">*</span></label>
              <input type="number" class="form-control" id="tarifHcb" formControlName="tarifHcb" placeholder="Ex : 3.07" tabindex="43"
                     [ngClass]="modeValorisationForm.get('tarifHcb').invalid && (modeValorisationForm.get('tarifHcb').dirty
                  || modeValorisationForm.get('tarifHcb').touched) ? 'is-invalid' : ''">
              <div class="invalid-feedback">
                <div *ngIf="modeValorisationForm.get('tarifHcb').errors?.['required']">Heure Creuse Basse est obligatoire</div>
              </div>
            </div>
            <div class="col-12 col-xxl-6">
              <label for="tarifHpb" class="form-label">Heure Pleine Basse (HPB)  <span class="required">*</span></label>
              <input type="number" class="form-control" id="tarifHpb" formControlName="tarifHpb" placeholder="Ex : 3.07" tabindex="44"
                         [ngClass]="modeValorisationForm.get('tarifHpb').invalid && (modeValorisationForm.get('tarifHpb').dirty
                      || modeValorisationForm.get('tarifHpb').touched) ? 'is-invalid' : ''">
              <div class="invalid-feedback">
                <div *ngIf="modeValorisationForm.get('tarifHpb').errors?.['required']">Heure Pleine Basse est obligatoire</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Intégration du fichier courbe de charge</h5>
    <button type="button" class="btn-close btn-primary" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <h6 class="btn-ouline-success-title">Sélectionner le format du fichier :</h6>
      <div class="btn-group d-block" role="group">
        <input type="radio" class="btn-check" id="formatSunleon" value="sunleon" [(ngModel)]="selectedFormat" (ngModelChange)="onFormatChange()">
        <label class="btn btn-outline-success" for="formatSunleon">Format Sunsmart</label>
        <input type="radio" class="btn-check" id="formatEnedis" value="enedis" [(ngModel)]="selectedFormat" (ngModelChange)="onFormatChange()">
        <label class="btn btn-outline-success" for="formatEnedis">Format Enedis</label>
      </div>
    </div>

    <div *ngIf="selectedFormat === 'sunleon'">
      <div class="mb-3">
        <label for="fileSunleon" class="form-label">Fichier courbe de charge (Sunsmart) <span class="required">*</span></label>
        <input type="file" id="fileSunleon" class="form-control" (change)="onFileSelected($event)" accept=".csv">
      </div>
    </div>

    <div *ngIf="selectedFormat === 'enedis'">
      <div class="mb-3">
        <label for="nomCourbeCharge" class="form-label">Nom de la courbe de charge<span class="required">*</span></label>
        <input type="text" id="nomCourbeCharge" class="form-control" [(ngModel)]="nomCourbeCharge" name="nomCourbeCharge" required
               [ngClass]="{'is-invalid': nomCourbeChargeError}" (ngModelChange)="validateNomCourbeCharge()">
        <div *ngIf="nomCourbeChargeError" class="invalid-feedback">
          Le nom de la courbe de charge est requis.
        </div>
      </div>
      <div class="mb-3">
        <label for="fileEnedis" class="form-label">Fichier courbe de charge (Enedis) <span class="required">*</span></label>
        <input type="file" id="fileEnedis" class="form-control" (change)="onFileSelected($event)" accept=".csv">
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex flex-column align-items-stretch">
    <div class="row">
      <div class="col-7">
        <button type="button" class="btn btn-modal btn-danger" (click)="modal.close('Close click')">Fermer</button>
      </div>
      <div class="col-5">
        <button type="submit" class="btn btn-modal btn-primary" (click)="onSubmit()"
                [disabled]="(selectedFormat === 'enedis' && nomCourbeChargeError) || !selectedFormat || formModalIsSubmitting">
          Valider
          <div *ngIf="formModalIsSubmitting" class="col-3 text-center spinner-border text-success" role="status"></div>
        </button>
      </div>
    </div>
  </div>
</ng-template>
